'use client';

import { singletonHook } from 'react-singleton-hook';
import { useSyncLocalStorage } from 'src/hooks/useSyncLocalStorage';

const useHasConnectedWalletBefore = () => {
	const state = useSyncLocalStorage<boolean>(`hasConnectedWalletBefore`, false);

	return state;
};

export default singletonHook([false, () => {}], useHasConnectedWalletBefore);
